import api from './api';

// LAKPED-8 — Pedidos y partes de trabajo (solo cuentas con orders_enabled)

const cleanParams = (params) => (
  Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ''))
);

export const getOrders = async (params = {}) => {
  const response = await api.get('/orders', { params: cleanParams(params) });
  return response.data;
};

export const getOrder = async (orderHash) => {
  const response = await api.get(`/orders/${orderHash}`);
  return response.data;
};

export const createOrder = async (data) => {
  const response = await api.post('/orders', data);
  return response.data;
};

export const updateOrder = async (orderHash, data) => {
  const response = await api.patch(`/orders/${orderHash}`, data);
  return response.data;
};

export const addWorkPart = async (orderHash, data) => {
  const response = await api.post(`/orders/${orderHash}/parts`, data);
  return response.data;
};

export const deleteWorkPart = async (partHash) => {
  await api.delete(`/orders/parts/${partHash}`);
};

export const getOrderClients = async (search = '') => {
  const response = await api.get('/orders/clients', { params: cleanParams({ search }) });
  return response.data;
};

export const getWorkResources = async (onlyActive = false) => {
  const response = await api.get('/orders/resources', { params: { only_active: onlyActive } });
  return response.data;
};

// LAKPED-7 — alta de pedido desde un documento escaneado
export const scanOrderDocument = async (file) => {
  const form = new FormData();
  form.append('file', file);
  const response = await api.post('/orders/scan', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 200000,
  });
  return response.data;
};

export const createOrderFromScan = async (data) => {
  const response = await api.post('/orders/from-scan', data);
  return response.data;
};

// LAKPED-10 — Ofertas y calculadora de tiempos
export const getOffers = async (params = {}) => {
  const response = await api.get('/orders/offers/list', { params: cleanParams(params) });
  return response.data;
};

export const getOffer = async (offerHash) => {
  const response = await api.get(`/orders/offers/${offerHash}`);
  return response.data;
};

export const createOffer = async (data) => {
  const response = await api.post('/orders/offers', data);
  return response.data;
};

export const updateOffer = async (offerHash, data) => {
  const response = await api.patch(`/orders/offers/${offerHash}`, data);
  return response.data;
};

export const suggestTimes = async (description, clientName, analysisHash) => {
  const params = { description };
  if (clientName) params.client_name = clientName;
  if (analysisHash) params.analysis_hash = analysisHash;
  const response = await api.get('/orders/offers/suggest/times', { params });
  return response.data;
};

// LAKPED-5: el cliente acepta la oferta y se convierte en pedido. Repetirlo no duplica nada.
export const offerToOrder = async (offerHash) => {
  const response = await api.post(`/orders/offers/${offerHash}/to-order`);
  return response.data;
};

// LAKPED-16.2: qué sabemos ya de una pieza — pedidos, ofertas y planos anteriores con ese código.
// El código va como parámetro, no en la ruta: el 15% de las referencias llevan barra.
export const getPartHistory = async (code, excludeHash = null) => {
  const params = { code };
  if (excludeHash) params.exclude_hash = excludeHash;
  const response = await api.get('/orders/part-history', { params });
  return response.data;
};

// LAKPED-16.5: la oferta de la que probablemente viene un pedido (mismo cliente, mismos artículos).
export const getOfferSuggestion = async ({ codes, clientHash, clientName }) => {
  const params = { codes: codes.join(',') };
  if (clientHash) params.client_hash = clientHash;
  else if (clientName) params.client_name = clientName;
  const response = await api.get('/orders/offer-suggestion', { params });
  return response.data || null;
};

// LAKPED-16.7: el panel de seguimiento, todo en una llamada.
export const getDashboard = async ({ year, clientHash } = {}) => {
  const params = {};
  if (year) params.year = year;
  if (clientHash) params.client_hash = clientHash;
  const response = await api.get('/orders/dashboard', { params });
  return response.data;
};
